import { h } from 'preact'
import { Provider } from 'react-redux'
import store from '../redux/store'

export const withStore = WrappedComponent =>
  function f(props) {
    return (
      <Provider store={store}>
        <WrappedComponent {...props} />
      </Provider>
    )
  }
